<!-- <div class="supportPage">
  <div><img src="../../assets/images/handshaking2.svg" alt="" /></div>
  <p>
    How much do you want to support with?
  </p>

  <form>
    <div class="ui form">
      <div class="field">
       
        <input type="number" placeholder="First Name" />
      </div>
    </div>
   
    <button
      (click)="startSearching()"
      type="submit"
      class="fluid ui primary button"
    >
      Next <i hidden class="fas fa-circle-notch fa-spin"></i>
    </button>
  </form>
</div> -->

<div
  id
  class="flex flex-column justify-center align-center h-100 text-center"
  id="support-page"
>
  <p class="para-title">How much would you like to give?</p>
  <div class="grid two money-boxes">
    <p class="box para-title" (click)="submitAmount($event)">N5,000</p>
    <p class="box para-title" (click)="submitAmount($event)">N10,000</p>
    <p class="box para-title" (click)="submitAmount($event)">N20,000</p>
    <p class="box para-title" (click)="submitAmount($event)">N50,000</p>
  </div>
  <small class="smallNotification" *ngIf="notification?.show">
    {{ notification?.message }}
  </small>
</div>

<div *ngIf="stage == '0'" class="inner-modal">
  <div class="inner-modal-content flex flex-column align-center text-center">
    <div class="para-title">No family available to support</div>
    <a class="link mt-4" (click)="stage = ''" class="goBack">go back</a>
  </div>
</div>

<div *ngIf="stage == '1'" class="inner-modal">
  <div class="inner-modal-content flex flex-column align-center text-center">
    <div class="para-title">We will search for {{ text }}</div>
    <button (click)="getFamily()" class="ui button primary basic mt-4">
      Next
    </button>
    <span (click)="stage = ''" class="goBack">go back</span>
  </div>
</div>

<div *ngIf="stage == '2'" class="inner-modal">
  <div class="inner-modal-content flex flex-column align-center text-center">
    <div class="three-dots-loader">
      <span class="circle"></span>
      <span class="circle"></span>
      <span class="circle"></span>
    </div>
    <p class="para-title">Searching..</p>
    <button (click)="stage = '1'" class="ui button basic mini negative mt-2">
      Cancel
    </button>
    <!-- <span (click)="stage = '1'" class="goBack">go back</span> -->
  </div>
</div>

<!-- <div class="inner-modal">
    <div class="inner-modal-content flex flex-column align-center text-center">
        <div class="para">We will find 200 families to show their account details</div>
        <button class="ui button primary basic mt-4">Transfer funds manually</button>
        <a class="mt-3 link" href="#">Select a bulk method</a>
    </div>
</div> -->

<div *ngIf="stage == '3'" class="inner-modal">
  <div class="inner-modal-content flex flex-column align-center text-center">
    <div class="para-title">Transfer fund to this family</div>
    <div class="para-body mt-4 mb-4">
      Find account details of {{ familyDetails?.family_name }} family below to
      support them
    </div>

    <ul class="list w-100 mt-4">
      <li>
        <span>Family name:</span>
        <span> {{ familyDetails?.family_name }}</span>
      </li>
      <li>
        <span>Bank:</span>
        <span> {{ familyDetails?.bank_name }} </span>
      </li>
      <li>
        <span>Account number:</span>
        <span>{{ familyDetails?.account_no }}</span>
      </li>
    </ul>

    <button class="ui basic button mt-4">
      <span (click)="gotoFamilyDetails()" class="mr-2"> Next </span>
    </button>
    <span (click)="stage = ''" class="goBack">go back</span>
  </div>
</div>

<div *ngIf="stage == '4'" class="inner-modal">
  <div class="inner-modal-content flex flex-column align-center text-center">
    <div class="para-title">
      We have selected a set of families for you to fund!
    </div>
    <a class="link mt-4" (click)="gotoFamily()" class="goBack modified"
      >continue</a
    >
  </div>
</div>
